import { Component, Inject, OnInit } from "@angular/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  ValidatorFn,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { NameInputDialogParams } from "./name-input-dialog.interface";
import { ShowOnSubmitAttemptErrorStateMatcher } from "../error-state-matcher";

@Component({
  selector: "app-name-input-dialog",
  templateUrl: "./name-input-dialog.component.html",
  styleUrls: ["./name-input-dialog.component.scss"],
  standalone: false,
})
export class NameInputDialogComponent implements OnInit {
  nameControl: UntypedFormGroup;
  errorStateMatcher = new ShowOnSubmitAttemptErrorStateMatcher();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: NameInputDialogParams,
    private dialogRef: MatDialogRef<NameInputDialogComponent>,
  ) {
    const requiredValidator: ValidatorFn = Validators.required.bind(
      null,
    ) as ValidatorFn;
    this.nameControl = new UntypedFormGroup({
      name: new UntypedFormControl("", requiredValidator),
    });
    if (data.currentName) {
      this.nameControl.get("name")?.setValue(data.currentName);
    }
  }

  ngOnInit(): void {}

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.errorStateMatcher.submitAttempted = true;
    if (this.nameControl.invalid) {
      return;
    }
    this.dialogRef.close({
      action: this.data.actionType,
      name: this.nameControl.get("name")?.value as string,
    });
  }
}
